import React, { memo } from 'react';
import { View, StyleSheet, TouchableOpacity } from 'react-native';
import { Text } from '../../ui/AppText';
import { LinearGradient } from 'expo-linear-gradient';
import {
    SLIM_HEIGHT,
    CARD_FONTS,
    CARD_ICONS,
    CARD_PADDING,
    CARD_RADIUS,
    CARD_SHADOW
} from './cardConstants';

/**
 * WorldMapCard - Slim horizontal card for World Map / Modo Foco
 * Premium purple-blue gradient with white bold fonts
 * Navigates to FocusMode screen
 */
const WorldMapCard = memo(({ onPress, isDarkMode = true }) => {
    const isLightMode = !isDarkMode;
    const cardColors = isLightMode ? ['#FFFFFF', '#F7F7FB'] : ['#1E3A5F', '#152238', '#0D1520'];

    return (
        <TouchableOpacity
            style={[styles.cardContainer, isLightMode && styles.cardContainerLight]}
            onPress={onPress}
            activeOpacity={0.9}
        >
            <LinearGradient
                colors={cardColors}
                start={{ x: 0, y: 0 }}
                end={{ x: 1, y: 1 }}
                style={[styles.card, isLightMode && styles.cardLight]}
            >
                <View style={styles.row}>
                    {/* Icon */}
                    {/* Glifo (nao emoji) nos dois temas: emoji ignora `color` e
                        ficaria fora da paleta azul dos demais icones da Home. */}
                    <Text style={[styles.icon, isLightMode && styles.iconLight]}>
                        ◎
                    </Text>

                    {/* Content */}
                    <View style={styles.content}>
                        <Text style={[styles.title, isLightMode && styles.titleLight]}>Modo Foco</Text>
                        <Text style={[styles.subtitle, isLightMode && styles.subtitleLight]}>Estudo intensivo</Text>
                    </View>
                </View>
            </LinearGradient>
        </TouchableOpacity>
    );
});

const styles = StyleSheet.create({
    cardContainer: {
        height: SLIM_HEIGHT,
        borderRadius: CARD_RADIUS.medium,
        overflow: 'hidden',
        shadowColor: '#1E3A5F',
        ...CARD_SHADOW.small,
    },

    cardContainerLight: {
        shadowColor: '#000',
        shadowOffset: { width: 0, height: 2 },
        shadowOpacity: 0.06,
        shadowRadius: 7,
        elevation: 2,
    },

    card: {
        flex: 1,
        paddingHorizontal: CARD_PADDING.horizontal,
        paddingVertical: CARD_PADDING.vertical,
        borderRadius: CARD_RADIUS.medium,
        borderWidth: 1,
        borderColor: 'rgba(255, 255, 255, 0.1)',
    },

    cardLight: {
        borderColor: '#E9E9F2',
    },

    row: {
        flex: 1,
        flexDirection: 'row',
        alignItems: 'center',
    },

    icon: {
        fontSize: CARD_ICONS.medium,
        marginRight: CARD_PADDING.medium,
        // Versao clara da matiz do cabecalho (210deg), p/ contrastar no card escuro.
        color: '#4A9EDB',
    },

    iconLight: {
        // Card branco -> a propria cor-base #03386C.
        color: '#03386C',
        fontWeight: '800',
    },

    content: {
        flex: 1,
    },

    title: {
        fontSize: CARD_FONTS.titleSmall,
        fontWeight: '800',
        color: '#FFFFFF',
    },

    titleLight: {
        color: '#111827',
    },

    subtitle: {
        fontSize: CARD_FONTS.subtitle,
        fontWeight: '500',
        color: 'rgba(255, 255, 255, 0.7)',
    },

    subtitleLight: {
        color: '#7C8194',
    },

    right: {
        alignItems: 'flex-end',
    },

    cta: {
        fontSize: 12,
        fontWeight: '600',
        color: '#FFFFFF',
    },
});

export default WorldMapCard;
